import { defaultWorkerCount, RequestWorkerPool } from '../../../workers/request-worker-pool';
import { FetchCopcWorker } from '../../../workers/worker-imports';
import { CopcWorkerRequest } from './types';

/** Workers that read a COPC with range requests and decompress its points. */
export class CopcWorkerPool extends RequestWorkerPool<CopcWorkerRequest> {
  constructor(workerCount = defaultWorkerCount()) {
    super(() => new FetchCopcWorker(), 'COPC', workerCount);
  }
}
